import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=f0afb72a&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0afb72a')) {
      api.createRecord('f0afb72a', component.options)
    } else {
      api.reload('f0afb72a', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=f0afb72a&", function () {
      api.rerender('f0afb72a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ZkCiUwGu0bS4/JS/comp/DateRangeExt.vue"
export default component.exports